export default [
    {
        path: 'motivo-baixa',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-motivo-baixa' */
            '@/views/almoxarifado/motivo-baixa/Index'
        ),
        redirect: 'motivo-baixa/index',
        children: [
            {
                name: 'almoxarifado-motivo-baixa-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-motivo-baixa' */
                    '@/views/almoxarifado/motivo-baixa/List.vue'
                ),
            },
            {
                name: 'almoxarifado-motivo-baixa-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-motivo-baixa' */
                    '@/views/almoxarifado/motivo-baixa/Form.vue'
                ),
            },
            {
                name: 'almoxarifado-motivo-baixa-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-motivo-baixa' */
                    '@/views/almoxarifado/motivo-baixa/Form.vue'
                ),
            },
        ],
    },
]